export default __webpack_public_path__ + "static/media/pepsico-logo.f8349d57.png";